import {
    REQUEST_UPDATE_BILLING, REQUEST_UPDATE_BILLING_FAILURE,
    REQUEST_UPDATE_BILLING_SUCCESS
} from "../../../constant/transaction/BillingConstant";


const initialState = {
    updateBilling: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updateBillingReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_BILLING:
            return {
                ...state,
                updateBilling: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_BILLING_SUCCESS:
            return {
                ...state,
                updateBilling: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_BILLING_FAILURE:
            return {
                ...state,
                updateBilling: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
